import { PaymentStatus } from '../types';

export const CLEANUP_DELAY_MS = 100;

export const PROCESSING_PAYMENT_STATES = [
    'AWAIT_CREATE_RESULT',
    'AWAIT_AUTHENTICATE_RESULT',
    'AWAIT_PAYMENT',
    'AWAIT_CANCEL_RESULT',
    'AWAIT_EXECUTE_RESULT',
    'CREATED'
];

export const isProcessingPaymentStatus = (status: PaymentStatus) => {
    return PROCESSING_PAYMENT_STATES.includes(status);
};
